export default "__VITE_ASSET__C4f5Y5So__"